import React from "react";
import {
  labelStyle,
  labelTextStyle,
  labelDetailsStyle,
  labelTextWrapperStyle,
} from "./label.css";

export function Label({ children, text, details, ...rest }) {
  return (
    <label className={labelStyle} {...rest}>
      <span className={labelTextWrapperStyle}>
        <span className={labelTextStyle}>{text}</span>
        {details ? <span className={labelDetailsStyle}> {details}</span> : null}
      </span>
      {children}
    </label>
  );
}
